package com.parmartechnologies.storage.table.customer


import com.parmartechnologies.core.feature.customer.model.Customer
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.table.DatabaseTable

class CustomerDatabaseTable : DatabaseTable() {
    fun insert(item: Customer?) {
        item.let { DatabaseCollection().insert(item!!, Customer.serializer())}
    }

    fun insert(items: List<Customer>?) {
        items.let { DatabaseCollection().insertAll(items!!, Customer.serializer())}
    }

    fun retrieve(id: String, callback: (List<Customer>) -> Unit) {
        DatabaseCollection().findAllByBusinessId(id,Customer.serializer()){
            callback(it)
        }
    }

    fun search(id: String, query: String, callback: (List<Customer>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("business_id",id))
        val orQuery : Map<String,Any> = mapOf(Pair("business_id",id))
        DatabaseCollection().findAll(andQuery,orQuery,Customer.serializer()){
            callback(it)
        }
    }

    fun LastSyncDate(id: String, callback: (String?) -> Unit) {
//        val table = AppDatabase.shared().database?.customerTableQueries
//        scope.launch {
//            val item = table?.LastSyncDate(
//                id
//            )?.awaitAsOneOrNull()
//            callback(item?.UpdatedAt)
//        }
        callback("")
    }
}